import React, {useEffect, useState} from 'react'
import styles from './UIGameVote.module.scss'
import {VoteState} from '@colonist/game-state-types'
import clsx from 'clsx'
import {T} from '../../common/T'
import {UIGameMobileTimerBar} from '../UIGameMobileTimerBar/UIGameMobileTimerBar'
import {PlayerColor} from '@colonist/game-states'
import {UIGameVoteParticipants} from './UIGameVoteParticipants'
import {UIGameVoteActions} from './UIGameVoteActions'
import {Sound} from '../../utils/sound'

export interface UIGameVoteProps {
    voteState: VoteState
    onAccept: () => void
    onReject: () => void
    className?: string | undefined
}

export const UIGameVote = ({voteState, onAccept, onReject, className}: UIGameVoteProps) => {
    const initialTimeLeftMs = voteState.duration - voteState.timePassed
    const [timeLeftMs, setTimeLeftMs] = useState(initialTimeLeftMs)

    useEffect(() => {
        Sound.playSound(Sound.SoundType.VoteReminder)
    }, [])

    useEffect(() => {
        setTimeLeftMs(initialTimeLeftMs)
        if(timeLeftMs <= 0) return

        const interval = setInterval(() => {
            setTimeLeftMs((prev) => {
                const next = prev - 100
                if(next <= 0) {
                    clearInterval(interval)
                    return 0
                }
                return next
            })
        }, 100)

        return () => clearInterval(interval)
    }, [initialTimeLeftMs])

    const timeLeftPercentage = Math.max(0, Math.min(1, timeLeftMs / voteState.duration)) * 100

    return (
        <div className={clsx(styles.container, className)}>
            <div>
                <div className={styles.title}><T id={voteState.title} /></div>
                <div className={styles.description}>
                    <T id={{
                        key: 'strings:game.vote.playersRequiredForVoteToPass',
                        options: {
                            count: voteState.requiredNumberOfAcceptVotesToPass,
                        },
                    }} />
                </div>
            </div>

            <UIGameMobileTimerBar
                isAnimated
                timeLeftPercentage={timeLeftPercentage}
                className={styles.timerBar}
                currentTurnPlayerColor={PlayerColor.Orange}
            />
            <UIGameVoteParticipants
                acceptedVotes={voteState.acceptedVotes}
                declinedVotes={voteState.declinedVotes}
                participatingPlayers={voteState.participatingPlayers}
            />
            <UIGameVoteActions
                acceptedVotes={voteState.acceptedVotes}
                declinedVotes={voteState.declinedVotes}
                onAccept={onAccept}
                onDecline={onReject}
            />
        </div>
    )
}
